export default __webpack_public_path__ + "static/media/like.ce5099a6.svg";